import { Injectable } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { UserNotificationApiService } from '../core/services/api/user-notification-api.service';
import { ResolverService } from '../core/services/base/resolver.service';


@Injectable()
export class DashboardService {

  constructor(
    private userNotificationApiService: UserNotificationApiService,
    private resolverService: ResolverService
  ) { }


  getUserNotificationIsNotReadCounter() {
    return this.userNotificationApiService.getUserNotificationIsNotReadCounter();
  }

  resolveUserNotificationIsNotReadCounter() {
    this.resolverService.onResolverStart();
    return this.getUserNotificationIsNotReadCounter()
      .pipe(
        finalize(this.resolverService.onResolverStop)
      );
  }


  openInNewTab(hash: any) {
    const baseUrl = window.location.origin; // Obtiene la parte base de la URL actual
    const relativeUrl = `/manufacturing-orders/viewer/${hash}/info`;
    const fullUrl = `${baseUrl}${relativeUrl}`;
    window.open(fullUrl, '_blank');
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/dashboard/dashboard.service.ts